// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SportsbetPreferencesQueryVariables = Types.Exact<{
  userPreferenceId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  site?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SportsbetPreferencesQuery = { __typename?: 'Query', sportsbetPreferences?: { __typename?: 'SportsbetPreferences', id: string, getUserPreferencesById?: { __typename?: 'SportsbetPreferencesUserPreference', id: string, currency: Types.Currency, wallets?: Array<Types.Currency>, colorScheme: Types.ColorScheme } } };


export const SportsbetPreferencesDocument = /*#__PURE__*/ gql`
    query SportsbetPreferences($userPreferenceId: ID, $site: String) {
  sportsbetPreferences {
    id
    getUserPreferencesById(id: $userPreferenceId, site: $site) {
      id
      currency
      wallets
      colorScheme
    }
  }
}
    `;
export function useSportsbetPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>(SportsbetPreferencesDocument, options);
      }
export function useSportsbetPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>(SportsbetPreferencesDocument, options);
        }
export function useSportsbetPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>(SportsbetPreferencesDocument, options);
        }
export type SportsbetPreferencesQueryHookResult = ReturnType<typeof useSportsbetPreferencesQuery>;
export type SportsbetPreferencesLazyQueryHookResult = ReturnType<typeof useSportsbetPreferencesLazyQuery>;
export type SportsbetPreferencesSuspenseQueryHookResult = ReturnType<typeof useSportsbetPreferencesSuspenseQuery>;
export type SportsbetPreferencesQueryResult = Apollo.QueryResult<SportsbetPreferencesQuery, SportsbetPreferencesQueryVariables>;